<template>
    <p class="middleTitle" style="margin-bottom:0px">
        <span>{{title}}</span>
    </p>
</template>
<script>
export default {
    props: ['title'],
    components: {
    },
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
}
</script>
<style scoped lang="less">
</style>